const isMetricSection = (
  s: PerformanceBoardTypes.SlideOut.SlideOutSection,
): s is PerformanceBoardTypes.SlideOut.MetricsSection => {
  return s.sectionType === 'Metric Widget';
};

export default isMetricSection;
